<template>
	<div>
        <Breadcrumbs main="User" title="Edit User" />
			<div class="container-fluid">
				<div class="row">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-body">
								<!---- Add user form starts ---->

								<form @submit.prevent="editUser" enctype="multipart/form-data">
									<div class="row">
										<div class="col-sm-6">
											<div class="mb-3">
												<label class="control-label">Name <span class="required">*</span></label>
												<input v-model="users.name" class="form-control" type="text" v-bind:class="{ 'is-invalid': Boolean(errors.name) }" @keypress="alphaSpacesOnly" minlength="3" maxlength="100"/>
												<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>
										</div>
									
										<div class="col-sm-6">
											<div class="mb-3">
												<label class="control-label">Email</label>
												<input v-model="users.email" class="form-control" type="text" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"/>
												<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>
										</div>
									
									</div>

									<div class="row">
										<div class="col-sm-6">
											<div class="mb-3">
												<label class="control-label">Phone <span class="required">*</span></label>
												<input v-model="users.phone_number" class="form-control" type="text" v-bind:class="{ 'is-invalid': Boolean(errors.phone) }" @keypress="numbersOnly" minlength="10" maxlength="10"/>
												<div v-for="(val, index) in errors.phone" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-sm-6">
											<div class="mb-3">
												<label class="control-label">User Image <span>[Allowed Formats: jpg, jpeg, png]</span></label>
												<input ref="fileinput" id="fileinput" type="file" @change="setFile" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.image) }" />
												<div><span>Leave this field empty if you don't want to add/edit the image</span></div>
												<div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>
										</div>

										

										<div class="col-md-6 mt-3">
											<div>
												<img v-if="Boolean(users.image)" v-bind:src="$image_url + users.image" alt="Image not found" class="edit-image" height="60" width="60"/>
											
												<img v-else class="image-preview" v-bind:src="preview_image" height="60" width="60">
											</div>
										</div>
									</div>

										
									<div class="row">
										<div class="col-md-12">
											<button type="submit" class="btn btn-primary me-2">Update</button>
											<router-link :to="{ name: 'viewuser' }" class="btn btn-light">Cancel</router-link>
										</div>
									</div>
								</form>

								<!----Add user form ends ----->
							</div>
						</div>
					</div>
				</div>
			</div>
	</div>
</template>
<script>
	export default {
		name: "EditUserPage",
		data() {
			return {
				users: {
					id: "",
					name: "",
					email: "",
					phone_number: "",
					image: "",
				},
				image: '',
				preview_image: null,
				token: "",
				errors: {},
			};
		},
		mounted() {},

		created() {
			this.fetchUser();
		},

		methods: {

			numbersOnly(event) {
		      let keyCode = event.keyCode;
		      if (keyCode < 48 || keyCode > 57) {
		        event.preventDefault();
		      }
		    },

		    alphaSpacesOnly(event) {
		    	let keyCode = event.keyCode;
			    if ((keyCode >= 65 && keyCode <= 90) || 
			    	(keyCode >= 97 && keyCode <= 122) ||			    	
			    	(keyCode == 32)) {
			        return;
			    } else {
			    	event.preventDefault();
			    }
		    },

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			fetchUser() {
				this.getToken();
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/api/admin/users/show?user_id=" + this.$route.params.id, config)
					.then((response) => {
						this.users = response.data.data;
						console.log(this.users);
					})
					.catch((err) => console.log(err));
			},

			setFile(e) {
				this.image = e.target.files[0];
				this.preview_image = URL.createObjectURL(this.image);
			},

			editUser() {
				this.getToken();
				let formData = new FormData();
				formData.append("user_id", this.$route.params.id);
				formData.append("name", this.users.name);
				formData.append("email", this.users.email);
				formData.append("phone", this.users.phone_number);
				formData.append("image", this.image);
				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				url = "/api/admin/users/edit";

				console.log(formData);

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.$router.push({ name: "viewuser" });
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								console.log(error.response.data);
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			clearForm() {
				this.users.name = "";
				this.users.email = "";
				this.users.phone_number = "";
				// this.user.password = "";
				// this.user.confirm_password = "";
				this.users.image = null;
				this.errors = {};
				//this.$ref.fileinput.value = null;
				document.getElementById('fileinput').value = '';
			},
		},
	};
</script>
